"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Users = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Users = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Users__clip0__".concat(id) : 'Users__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 7.6a3.6 3.6 0 11-7.201-.001A3.6 3.6 0 0112 7.6zm5.402-1.2a3 3 0 10-.001 6.001 3 3 0 000-6.001zm-2.461 9.192a3.601 3.601 0 00-3.23-1.992H5.087a3.601 3.601 0 00-3.23 1.992L.129 19.06a1.2 1.2 0 001.069 1.74H15.6a1.2 1.2 0 001.068-1.74l-1.728-3.468zm7.79 1.188l1.14 2.28a1.2 1.2 0 01-1.068 1.74h-3.805a3.6 3.6 0 00-.18-2.808L17.222 14.8h2.292c1.36 0 2.605.765 3.217 1.98z", clipRule: "evenodd" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
};
exports.Users = Users;
//# sourceMappingURL=users.js.map